export default {
  id: 'clickoutside',
  bind: function (el, {value}) {
    let onClickOutside = value
    el.handler = function (e) {
      if (el && !el.contains(e.target)) {
        onClickOutside(e)
      }
    }
    document.addEventListener('click', el.handler, true)
  },
  unbind: function (el) {
    document.removeEventListener('click', el.handler, true)
    el.handler = null
  },
  install (Vue) {
    Vue.directive('clickoutside', {
      // bind: this.bind,
      // unbind: this.unbind
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/GenRedOne/assets/js/directive.js